import { createAction } from 'redux-act';
import { toastr } from 'react-redux-toastr';
import { url } from 'utils/url';
import Axios from 'axios';

const baseUrl = url;
export const WEB_MENUS_FETCH = createAction('WEB_MENUS_FETCH');
export const WEB_MENUS_FETCH_DATA_SUCCESS = createAction(
  'WEB_MENUS_FETCH_DATA_SUCCESS'
);
export const WEB_MENUS_FETCH_DATA_FAIL = createAction(
  'WEB_MENUS_FETCH_DATA_FAIL'
);

export const WEB_MENUS_DELETE_INIT = createAction('WEB_MENUS_DELETE_INIT');
export const WEB_MENUS_DELETE_SUCCESS = createAction(
  'WEB_MENUS_DELETE_SUCCESS'
);
export const WEB_MENUS_DELETE_FAIL = createAction('WEB_MENUS_DELETE_FAIL');

export const WEB_MENUS_CLEAR_DATA = createAction('WEB_MENUS_CLEAR_DATA');

export const WEB_MENUS_CREATE_INIT = createAction('WEB_MENUS_CREATE_INIT');
export const WEB_MENUS_CREATE_SUCCESS = createAction(
  'WEB_MENUS_CREATE_SUCCESS'
);
export const WEB_MENUS_CREATE_FAIL = createAction('WEB_MENUS_CREATE_FAIL');

export const WEB_MENUS_MODIFY_INIT = createAction('WEB_MENUS_MODIFY_INIT');
export const WEB_MENUS_MODIFY_SUCCESS = createAction(
  'WEB_MENUS_MODIFY_SUCCESS'
);
export const WEB_MENUS_MODIFY_FAIL = createAction('WEB_MENUS_MODIFY_FAIL');

export const WEB_MENUS_CLEAN_UP = createAction('WEB_MENUS_CLEAN_UP');

export const WEB_MENUS_CLEAR_DATA_LOGOUT = createAction(
  'WEB_MENUS_CLEAR_DATA_LOGOUT'
);
export const WEB_MENUS_BULK = createAction('WEB_MENUS_BULK');

export const SET_WEB_MENUS = createAction('SET_WEB_MENUS');

export const fetchWebMenus = ({ siteId }) => {
  return async (dispatch, getState) => {
    dispatch(WEB_MENUS_FETCH());
    let webMenusData;
    try {
      webMenusData = await Axios.get(`${baseUrl}/webMenus/list/${siteId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(WEB_MENUS_FETCH_DATA_FAIL({ error }));
    }
    const WEB_MENUS = { ...webMenusData.data };
    return dispatch(
      WEB_MENUS_FETCH_DATA_SUCCESS({
        list: getState().webMenus.list,
        WEB_MENUS,
      })
    );
  };
};

export const addWebMenus = (payload) => {
  return async (dispatch, getState) => {
    dispatch(WEB_MENUS_FETCH());
    try {
      webMenusData = await Axios.post(`${baseUrl}/webMenus/create`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(WEB_MENUS_CREATE_FAIL({ error }));
    }
    return dispatch(WEB_MENUS_CREATE_SUCCESS());
  };
};

export const updateWebMenus = (id, payload) => {
  return async (dispatch, getState) => {
    dispatch(WEB_MENUS_FETCH());
    try {
      webMenusData = await Axios.put(`${baseUrl}/webMenus/${id}`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(WEB_MENUS_MODIFY_FAIL({ error }));
    }
    return dispatch(WEB_MENUS_MODIFY_SUCCESS());
  };
};

export const deleteWebMenu = (id, cb) => {
  console.log(id);
  return async (dispatch, getState) => {
    try {
      await Axios.delete(`${baseUrl}/webMenus/${id.id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      cb && cb();
    } catch (error) {
      console.log(error);
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('Failed', errorMessage);
      return dispatch(WEB_MENUS_DELETE_FAIL({ error }));
    }
    return dispatch(WEB_MENUS_DELETE_SUCCESS());
  };
};
